(function ($, document, window) {
    'use strict';

    $(function () {
        const $sidebar = $('.js-course-sidebar');
        const $siteHeader = $('.js-site-header');
        const $stickyHeader = $('.js-sticky-header');
        const $inPage = $('.js-in-page');
        const $contentContainer = $('.js-single-course-container');
        const breakContentSidebar = getComputedStyle(document.documentElement).getPropertyValue('--break-grid-content-sidebar').trim();

        var matchMediaLg = window.matchMedia(`(min-width: ${breakContentSidebar})`);
        var matchMediaXl = window.matchMedia('(min-width: 1400px)');
        var fixedClass = 'is-fixed';
        var absoluteClass = 'is-absolute';

        function getHeaderHeight() {
            return $('body').hasClass('sticky-header-active')
                ? $stickyHeader.outerHeight()
                : $siteHeader.outerHeight();
        }

        function getInPageHeight() {
            return $inPage.length
                ? $inPage.outerHeight()
                : 0;
        }

        function getAdminBarHeight() {
            return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--wp-admin--admin-bar--height')) || 0;
        }

        // required as the js-single-course-container is inside an <article> with this margin
        function getSectionSpacing() {
            if (matchMediaXl.matches) {
                return 100;
            } else if (matchMediaLg.matches) {
                return 80;
            }
        }

        /**
         * Determines whether or not the sidebar can be fixed.
         * 
         * @returns {boolean} True if sidebar can be fixed, false otherwise.
         */
        function canSidebarBeFixed() {
            if (!$sidebar.length || !matchMediaLg.matches) {
                return false;
            }

            const headerHeight = getHeaderHeight();
            const inPageHeight = getInPageHeight();
            const adminBarHeight = getAdminBarHeight();
            const sidebarHeight = $sidebar.outerHeight();
            const availableHeight = window.innerHeight - (headerHeight + inPageHeight + adminBarHeight);

            return sidebarHeight < availableHeight;
        }

        /**
         * Handles adding a fixed class and width to the course sidebar once the sidebar is vertically centered.
         */
        function handleFixedClass() {
            if (!$sidebar.length || !matchMediaLg.matches) {
                return;
            }

            const adminBarHeight = getAdminBarHeight();
            const headerHeight = getHeaderHeight();
            const inPageHeight = getInPageHeight();
            const sidebarHeight = $sidebar.outerHeight();
            const sectionSpacing = getSectionSpacing();
            const topPadding = ($(window).height() - sidebarHeight) / 2;
            const bottomPadding = $contentContainer.outerHeight() + sidebarHeight - (sectionSpacing + adminBarHeight + headerHeight + inPageHeight);
            const scrollTop = $(window).scrollTop() - adminBarHeight;
            const scrollBottom = bottomPadding;

            /**
             * Adjusts the sidebar width based on media query and scroll position.
             * 
             * @param   {MediaQueryListEvent} e - The media query change event.
             * @return  {void}
             */
            function handleSidebarWidth(e) {
                // if the scroll position relative to the top of the window is >= bottomPadding          
                if (scrollTop >= bottomPadding && canSidebarBeFixed()) {
                    $sidebar.removeClass(fixedClass).addClass(absoluteClass).css({
                        'width': $sidebar.parent().width(),
                        'top': `${scrollBottom}px`,
                    });
                    // if the scroll position relative to the top of the window is >= topPadding
                } else if (scrollTop >= topPadding && canSidebarBeFixed()) {
                    $sidebar.removeClass(absoluteClass).addClass(fixedClass).css({
                        'width': $sidebar.parent().width(),
                        'top': '',
                    });
                } else {
                    $sidebar.removeClass(fixedClass).removeClass(absoluteClass).css({
                        'width': '',
                        'top': '',
                    });
                }
            }

            handleSidebarWidth(matchMediaLg);

            matchMediaLg.addEventListener('change', handleSidebarWidth);
        }

        $(window).on('scroll resize', handleFixedClass);

        handleFixedClass();
    });
})(jQuery, document, window);